import React, { useState, useEffect } from "react";
import { Card, Divider, Button, Descriptions } from "antd";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { generateClient } from "aws-amplify/api";
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import { getPayment, getBattery } from "../../../../graphql/queries";
import { deletePayment, deleteBattery } from "../../../../graphql/mutations";
import { fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth';

const client = generateClient();

const DetailedPayments = () => {
  const { paymentID } = useParams();
  const navigate = useNavigate();
  const [payment, setPayment] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      try {
        const { data } = await client.graphql({
          query: getPayment,
          variables: { id: paymentID },
        });
        setPayment(data.getPayment);
      } catch (error) {
        console.error("Error fetching battery details:", error);
      }
    };

    fetchPaymentDetails();
  }, [paymentID]);

  useEffect(() => {
    checkUserRole();
  }, [client]);

  async function checkUserRole() {
    try {
      const session = await fetchAuthSession();
      const userAttributes = await fetchUserAttributes();

      const isAdminUser = userAttributes['custom:isAdmin'] === 'true';

      const groups = session.tokens.accessToken.payload['cognito:groups'];

      const isInAdminGroup = groups && groups.includes('Admins');
      const isInOperatorsGroup = groups && groups.includes('Operators');

      setIsAdmin(isAdminUser || isInAdminGroup);

    } catch (error) {
      console.error("Error checking user role:", error);
    }
  }
  const handleDelete = async () => {
    try {
      // if (payment.batteryInNumber) {
      //   const batteryResponse = await client.graphql({
      //     query: getBattery,
      //     variables: { number: payment.batteryInNumber },
      //   });
      //   const batteryId = batteryResponse.data.getBatteryByNumber.items[0]?.id;

      //   if (batteryId) {
      //     await client.graphql({
      //       query: deleteBattery,
      //       variables: { input: { id: batteryId } },
      //     });
      //   }
      // }
      await client.graphql({
        query: deletePayment,
        variables: { input: { id: paymentID } },
      });
      toast.success("Payment and battery deleted successfully");
      navigate('/payment');
    } catch (error) {
      toast.error("Error deleting payment");
      console.error("Error deleting payment!", error);
    }
  };

  if (!payment) {
    return <div>Loading...</div>;
  }

  return (
    <Card title={`Payment Details`} style={{ margin: 20 }}>
      <Descriptions bordered column={{ lg: 1, md: 1, sm: 1 }}>
        <Descriptions.Item label="Rider Name">{payment.name}</Descriptions.Item>
        <Descriptions.Item label="Rider Phone Number">{payment.phone_number}</Descriptions.Item>
        <Descriptions.Item label="Amount">{payment.amount}</Descriptions.Item>
        <Descriptions.Item label="Platform">{payment.platform}</Descriptions.Item>
        <Descriptions.Item label="Payment Method">{payment.paymentMethod}</Descriptions.Item>
        <Descriptions.Item label="Status">{payment.status}</Descriptions.Item>
        <Descriptions.Item label="Details">{payment.details}</Descriptions.Item>
        <Descriptions.Item label="Reference">{payment.reference}</Descriptions.Item>
      </Descriptions>
      <Divider />
      <div style={{ display: "flex", justifyContent: "space-around", padding: 20, gap: 50 }}>
        {isAdmin && (
          <Button block type="danger" size="large" onClick={handleDelete}>
            Delete Payment
          </Button>
        )}
        <ToastContainer />
      </div>
    </Card>
  );
};

export default DetailedPayments;
